import { VerbitSwitch, VerbitSwitchTrack, VerbitSwitchDot } from './styles'

type SwitchControlProps = {
    isChecked: boolean
    onChange: (value: boolean) => void
    ariaLabel?: string
    isDisabled?: boolean
}

const Switch = (props: SwitchControlProps) => {
    const { isChecked, onChange, ariaLabel = '', isDisabled = false } = props
    const handleChange = (value: boolean) => {
        onChange(!value)
    }

    return (
        <VerbitSwitch id="toggle-switch" aria-label={ariaLabel} onChange={handleChange} isChecked={isChecked} isDisabled={isDisabled}>
            <VerbitSwitchTrack $isChecked={isChecked}>
                <VerbitSwitchDot $isChecked={isChecked} />
            </VerbitSwitchTrack>
        </VerbitSwitch>
    )
}

export default Switch
